import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'WeployDesignLanguage/Dialog';
import Button from 'WeployDesignLanguage/buttons/Button';

const DeleteUserFailureDialog = ({
  title,
  confirmAction,
  content,
  onClose,
  open,
}) => (
  <Dialog onClose={onClose} open={open}>
    <Dialog.Title onClose={onClose}>
      {title}
    </Dialog.Title>
    <Dialog.Content>{content}</Dialog.Content>
    <Dialog.Actions>
      <Button
        appearance={Button.TEXT}
        onClick={onClose}
      >
        Ok
      </Button>
      {confirmAction}
    </Dialog.Actions>
  </Dialog>
);

DeleteUserFailureDialog.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  confirmAction: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  content: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

DeleteUserFailureDialog.defaultProps = {
  confirmAction: null,
  content: null,
};

export default DeleteUserFailureDialog;
